import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CreateGrowerAccountRequest,
  CreateGrowerAccountResponse,
  GrowerAccountResponse,
  GrowerAccountSummary,
  PlantResponse,
  ShuntingYardResponse,
  TransloadingStationResponse,
  UpdateGrowerAccountPutRequest
} from '../interfaces/api-responses';

@Injectable({ providedIn: 'root' })
export class ReferenceDataService {
  constructor(private readonly http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('accessToken');
    const tokenType = localStorage.getItem('tokenType') || 'Bearer';
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `${tokenType} ${token}`;
    return new HttpHeaders(headers);
  }

  async getGrowerAccounts(): Promise<GrowerAccountResponse> {
    const url = `${environment.apiBaseUrl}/api/v1/reference-data/grower-accounts`;
    const headers = this.getAuthHeaders();
    return await firstValueFrom(this.http.get<GrowerAccountResponse>(url, { headers }));
  }

  async createGrowerAccount(body: CreateGrowerAccountRequest): Promise<CreateGrowerAccountResponse> {
    const url = `${environment.apiBaseUrl}/api/v1/reference-data/grower-accounts`;
    const headers = this.getAuthHeaders();
    return await firstValueFrom(this.http.post<CreateGrowerAccountResponse>(url, body, { headers }));
  }

  async updateGrowerAccount(id: number, body: UpdateGrowerAccountPutRequest): Promise<GrowerAccountSummary> {
    const url = `${environment.apiBaseUrl}/api/v1/reference-data/grower-accounts/${id}`;
    const headers = this.getAuthHeaders();
    return await firstValueFrom(this.http.put<GrowerAccountSummary>(url, body, { headers }));
  }

  async getTransloadingStations(): Promise<TransloadingStationResponse> {
    const url = `${environment.apiBaseUrl}/api/v1/reference-data/transloading-stations`;
    const headers = this.getAuthHeaders();
    return await firstValueFrom(this.http.get<TransloadingStationResponse>(url, { headers }));
  }

  async getPlants(): Promise<PlantResponse> {
    const url = `${environment.apiBaseUrl}/api/v1/reference-data/plants`;
    const headers = this.getAuthHeaders();
    return await firstValueFrom(this.http.get<PlantResponse>(url, { headers }));
  }

  async getShuntingYardsByPlantId(plantId: number): Promise<ShuntingYardResponse> {
    const url = `${environment.apiBaseUrl}/api/v1/reference-data/shunting-yards?plantId=${plantId}`;
    const headers = this.getAuthHeaders();
    return await firstValueFrom(this.http.get<ShuntingYardResponse>(url, { headers }));
  }
}
